import * as React from 'react';
import '../../contexts/GlobalActionsContext/GlobalActionsContext.esm.js';
import { ToggleContext } from '../../contexts/ToggleContext/ToggleContext.esm.js';
import '../../contexts/VideoContext/VideoContext.esm.js';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import { isServer } from '../../utils/misc.esm.js';

/**
 * ABTestSection
 * This component won't work as currently we did not implement feature flag sharing between Toggle and Contentful.
 * Previously ABTestSection relied on LaunchDarkly flags that were set in Contentful.
 * Now feature flags are still set in Contentful, but they also need to be set in Toggle which is a separate feature
 * flags service and there is no bridge connection.
 * By default only first version is picked.
 */
var ABTestSection = function (_a) {
    var _b, _c, _d, _e;
    var fields = _a.fields;
    var flags = React.useContext(ToggleContext);
    if (!fields) {
        // eslint-disable-next-line no-console
        console.warn("[ABTestSection] - Could not find fields from Contentful");
        return null;
    }
    var abTestVariations = fields.abTestVariations, featureFlagName = fields.featureFlagName;
    if (isServer() || Object.keys(flags).length === 0) {
        // render first variation
        return (React.createElement(BaseNucleobaseComponent, { key: (_b = abTestVariations[0].fields) === null || _b === void 0 ? void 0 : _b.cmsBlock.sys.id, source: (_c = abTestVariations[0].fields) === null || _c === void 0 ? void 0 : _c.cmsBlock }));
    }
    var experiment = flags[featureFlagName];
    if (experiment === undefined) {
        // eslint-disable-next-line no-console
        console.warn("[ABTestSection] - Could not find experiment with '".concat(featureFlagName, "'"));
        return null;
    }
    var variation = abTestVariations.find(function (abTest) {
        var _a, _b;
        return ((_a = abTest.fields) === null || _a === void 0 ? void 0 : _a.variationName) === experiment ||
            experiment === ((_b = abTest.fields) === null || _b === void 0 ? void 0 : _b.experimentEnabledBooleanValue);
    });
    if (!variation) {
        // eslint-disable-next-line no-console
        console.warn("[ABTestSection] - Could not find variaton name: '".concat(experiment, "'"));
        return null;
    }
    return React.createElement(BaseNucleobaseComponent, { key: (_d = variation.fields) === null || _d === void 0 ? void 0 : _d.cmsBlock.sys.id, source: (_e = variation.fields) === null || _e === void 0 ? void 0 : _e.cmsBlock });
};

export { ABTestSection as default };
//# sourceMappingURL=ABTestSection.esm.js.map
